import { render } from "./IconDeviceMobile.vue?vue&type=template&id=83c57618&ts=true"
import script from "./IconDeviceMobile.vue?vue&type=script&lang=ts"
export * from "./IconDeviceMobile.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/paulbele/Code/repositories/maatoo-app-master/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__